import React, { createContext, useContext, useMemo } from 'react';
import { useSubdomain } from '../hooks/useSubdomain';
import topicMetadata from '../../topic-metadata';

const MetadataContext = createContext(null);

export function useMetadata() {
  const context = useContext(MetadataContext);
  if (!context) {
    throw new Error('useMetadata must be used within a MetadataProvider');
  }
  return context;
}

export function MetadataProvider({ children }) {
  const { subdomain } = useSubdomain();
  
  // Get the metadata for the current subdomain or fall back to default
  const metadata = useMemo(() => {
    return topicMetadata[subdomain] || topicMetadata.default;
  }, [subdomain]);
  
  return (
    <MetadataContext.Provider value={metadata}>
      {children}
    </MetadataContext.Provider>
  );
}
